import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>For example, if the project comprised finding general information
                                                about a particular topic on the
                                                internet, you could be searching forever as there may be
                                                limitless information out there on that
                                                subject. If you have set your target in terms of how long you
                                                will spend on the task, you can work
                                                towards delivering your output at a certain time. As well as
                                                this, of course, it would be useless to
                                                set a sales person a target of £10,000 if they don’t know
                                                whether this needs to be achieved in a
                                                day, a week, or a month!</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>TIPS FOR ACHIEVING YOUR SMART TARGETS
                                            </div>
                                            <p>The SMART system has been reviewed several times over the last 30
                                                years, and modern studies<a className="superscripttext "
                                                                            href="further_info.php?course=300"><sup>2</sup></a>
                                                have shown that SMART is still an effective means of attaining
                                                long-term goals. Here are some
                                                recommendations for maximising the impact of SMART plans.</p>
                                            <div className="border_subtitle">As far as possible, align your
                                                goals with your values
                                            </div>
                                            <p>If your goal does not reflect your character or your beliefs,
                                                then it is less likely that you will be
                                                motivated to achieve it. Recent reviews<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>2</sup></a> have
                                                shown that one of the key means of success with
                                                SMART is to tailor it to your own feelings and thoughts.</p>
                                            <div className="border_subtitle">Let 3 to 5 key people know about
                                                the goals you have set for yourself
                                            </div>
                                            <p>Finding supportive people who can encourage you is the key to
                                                successful goal-setting. Similarly, if
                                                someone other than you knows your plan it may help you to feel
                                                more motivated to carry it through!</p>
                                            <div className="border_subtitle">Get things that you might need
                                                ready before you need them
                                            </div>
                                            <p>If you prepare well, it will save a lot of time wasting and
                                                frustration later on.</p>
                                            <div className="border_subtitle">Minimise potential challenges</div>
                                            <div className="paraspace"><p>Follow these three easy steps:</p>
                                            </div>
                                            <ol className="brownbullet-list listcontentSpacing">
                                                <li><p>Create an action plan that is as thorough as possible
                                                    including all the steps you need
                                                    to go through to achieve your goal. These steps should be
                                                    measurable and have due
                                                    dates for each stage of the plan.</p></li>
                                                <li><p>Incorporate all your actions into your schedule. Add them
                                                    into your calendar and make
                                                    sure you include some flexible time in case of extenuating
                                                    circumstances that may
                                                    cause delays.</p></li>
                                                <li><p>Evaluate your progress regularly. There is nothing wrong
                                                    with adapting plans as
                                                    circumstances or priorities change. Anticipate any changes
                                                    that need to be made
                                                    so that you are not caught off guard.</p></li>

                                            </ol>
                                            <br/>
                                            <div className="border_subtitle">Aim to complete one task
                                                associated with your target every day
                                            </div>
                                            <p> Consistent actions will propel you towards your goal. Even
                                                if the task is a small one, remember that
                                                each action adds up and ticking something off your to-do
                                                list may even motivate you to do more!</p>
                                            <div className="border_subtitle">Ensure that you have a support
                                                system in place
                                            </div>
                                            <p>Consider the people around you who can provide encouragement,
                                                advice or feedback.</p>
                                            <div className="border_subtitle">Reward yourself</div>
                                            <p>Make sure you take time to congratulate yourself at each
                                                milestone; you don’t have to wait until
                                                you achieve the overall goal, especially if the goal is a
                                                long-term one. Something as simple as
                                                taking some time out for yourself or indulging in a special
                                                treat can motivate you to keep going
                                                to achieve the end goal.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}